define('app-Agents/modules/common/module',["./settings"], function (settings) {
    var container = $(settings.container);

    if (container.length === 0) {
        return null;
    }

    var module = {};

    require(["app/ui/dialog", "jqueryval"], function (dialog) {
        module.ShowLoadingScreen = function (txt) {
            var loadingDiv = $('<div class="text-center"><img src="/content/loading.gif" alt="Loading" title="Loading"/></div>');
            txt = txt || "";

            this.Loading = dialog.show(txt, loadingDiv, {
                noClose: true,
                draggable: false,
                resizable: false
            });
        }

        module.HideLoadingScreen = function () {
            if (this.Loading && this.Loading.close) {
                this.Loading.close();
            }
        }
    });

    return module;
});
